<template>
    <TitleBar
        @left-click="$emit('prev-page')"
        @right-click="$emit('next-page');"
        left-button-class="w-1/2"
        right-button-class="w-1/2 ml-auto"
        bar-class="h-block bg-white border-t border-50 flex"
    >
        <template v-slot:leftIcon v-if="hasPrevPage">
            <div class="flex items-center justify-start pr-3">
                <div class="px-3">
                    <LeftArrowIcon />
                </div>
                <div class="truncate">
                    {{ prevPageTitle }}
                </div>
            </div>
        </template>
        <template v-slot:rightIcon v-if="hasNextPage">
            <div class="flex items-center justify-end pl-3">
                <div class="truncate">
                    {{ nextPageTitle }}
                </div>
                <div class="px-3">
                    <RightArrowIcon class="block" />
                </div>
            </div>
        </template>
    </TitleBar>
</template>

<script>
import LeftArrowIcon from '@mobile/components/Icons/LeftArrowIcon.vue';
import RightArrowIcon from '@mobile/components/Icons/RightArrowIcon.vue';
import TitleBar from '@/components/TitleBar.vue';

export default {
    components: { TitleBar, LeftArrowIcon, RightArrowIcon },
    props: {
        prevPageTitle: {
            type: String,
            default: null,
        },
        nextPageTitle: {
            type: String,
            default: null,
        },
        hasPrevPage: {
            type: Boolean,
            required: true,
        },
        hasNextPage: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
